import { useState, useEffect } from 'react'
import { Row, Col, Form, Affix, Space } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import dayjs from 'dayjs'
import { useRouter } from 'next/router'
import { useStoreActions } from 'easy-peasy'

import _find from 'lodash/find'

import Title from 'components/Title'
import Button from 'components/Button'
import SelectTextButton from 'components/Choice/SelectTextButton'
import LayoutService from 'components/LayoutService'
import ServiceReservationSteps from 'components/ServiceReservationSteps'

import { masterDataService } from 'services'

import { categories } from 'constant/data'

import QrcodeToLine from '../QrcodeToLine'

import Styled from './styled'

const renderServices = services => {
  return (
    <>
      <div className="service-title-block">
        <Title level={2}>เลือกบริการที่ท่านต้องการ</Title>
      </div>

      <Form.Item
        name="choice_id"
        rules={[
          {
            required: true,
            message: 'กรุณาเลือกบริการที่ต้องการ',
          },
        ]}
      >
        <SelectTextButton services={services} />
      </Form.Item>
    </>
  )
}

export default function ChooseService() {
  const router = useRouter()
  const query = router.query

  const slug = query?.slug

  const [loading, setLoading] = useState(true)
  const [services, setServices] = useState([])
  const [productCategory, setProductCategory] = useState(null)
  const [selectedServiceId, setSelectedServiceId] = useState(null)
  const [showQrCode, setShowQrCode] = useState(false)

  const resetBooking = useStoreActions(actions => actions.reset.resetBooking)

  const getCategory = async () => {
    const category = _find(categories, ['url', slug])

    return await masterDataService({
      method: 'post',
      url: '/productCategory/query',
      data: {
        where: [
          {
            code: category?.code,
          },
        ],
        limit: 1,
      },
    })
      .then(res => res.data.data?.[0])
      .then(data => {
        setProductCategory(data)
        getServices(data?.id)

        return data
      })
  }

  const getServices = async categoryId => {
    return await masterDataService({
      method: 'post',
      url: '/sellingPrice/query',
      data: {
        where: [
          {
            saleContract: {
              type: 'STANDARD_PRICE',
              businessUnits: {
                code: 241,
              },
            },
            startDate: { $lte: dayjs().format() },
            product: {
              categoryId,
              isDisplayOnCustomerPortal: true,
            },
          },
        ],
        order: {
          product: {
            code: 'ASC',
          },
        },
        limit: 1000,
        relations: ['product.subCategory', 'product.category'],
      },
    })
      .then(res => res.data.data)
      .then(data => {
        setServices(data)

        return data
      })
  }

  useEffect(() => {
    if (slug) {
      setLoading(true)
      getCategory().finally(() => setLoading(false))
    }
  }, [slug])

  const handleValueChange = changedValues => {
    const { choice_id } = changedValues
    setSelectedServiceId(choice_id)
  }

  const onSubmit = value => {
    resetBooking()
    router.push(`/${query?.slug}/booking/${value?.choice_id}`)
  }

  const handleClickToLine = () => {
    setShowQrCode(true)
  }

  const renderServicesDesktop = services => {
    return (
      <Form
        colon={false}
        layout="vertical"
        requiredMark={false}
        onFinish={onSubmit}
        onValuesChange={handleValueChange}
      >
        <Row>
          <Col span={24} lg={24}>
            <div className="service-container">
              <div className="render-desktop-lg">
                <div className="step-process-desktop">
                  <ServiceReservationSteps step={0} />
                </div>
              </div>

              {renderServices(services)}

              {loading && (
                <div className="spin">
                  <LoadingOutlined spin />
                </div>
              )}

              <div className="button-submit">
                <Space>
                  <Button style={{ width: 'auto' }} type="ghost" onClick={handleClickToLine}>
                    ขอคำแนะนำการเลือกบริการผ่าน LINE
                  </Button>

                  <Button htmlType="submit" block disabled={!selectedServiceId}>
                    ไปต่อ
                  </Button>
                </Space>
              </div>
            </div>
          </Col>
        </Row>
      </Form>
    )
  }

  const renderServicesMobile = services => {
    return (
      <Form
        colon={false}
        layout="vertical"
        requiredMark={false}
        onFinish={onSubmit}
        onValuesChange={handleValueChange}
      >
        <div className="service-container">
          {loading && (
            <div className="spin">
              <LoadingOutlined spin />
            </div>
          )}

          {renderServices(services)}
        </div>

        <Affix offsetBottom={0}>
          <div className="button-submit-mobile">
            <Space direction="vertical" style={{ width: '100%' }}>
              <Button htmlType="submit" block>
                ไปต่อ
              </Button>

              <Button block type="ghost" onClick={handleClickToLine}>
                ขอคำแนะนำการเลือกบริการผ่าน LINE
              </Button>
            </Space>
          </div>
        </Affix>
      </Form>
    )
  }

  if (showQrCode) {
    return (
      <QrcodeToLine
        categoryName={productCategory?.name}
        onBack={() => {
          setShowQrCode(false)
        }}
      />
    )
  }

  return (
    <LayoutService title="เลือกบริการที่ท่านต้องการ" needLogin={false}>
      <Styled>
        <div className="render-desktop-lg">
          <div className="content-page">{renderServicesDesktop(services)}</div>
        </div>

        <div className="render-mobile-lg">
          <div className="content-page">
            <div className="step-process-mobile">
              <ServiceReservationSteps step={0} />
            </div>
            {renderServicesMobile(services)}
          </div>
        </div>
      </Styled>
    </LayoutService>
  )
}
